import React from "react";

const IndividualTaslTable = ({ data }) => {
  return (
    <div>
      {data.map((employee) => (
        <div key={employee.empcode}>
          <h4>Employee Code: {employee.empcode}</h4>
          <p>Task Count: {employee.task_count}</p>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Task ID</th>
                <th>Task Code</th>
                <th>Task</th>
                <th>Alloted Section</th>
                <th>Assigned On</th>
                <th>Teacher</th>
                <th>Updated On</th>
              </tr>
            </thead>
            <tbody>
              {employee.ttaList.map((task) => (
                <tr key={task.taskId}>
                  <td>{task.taskId}</td>
                  <td>{task.task_code}</td>
                  <td>{task.task}</td>
                  <td>{task.alloted_section}</td>
                  <td>{task.assigned_on}</td>
                  <td>{task.teacher}</td>
                  <td>{task.updated_on || "Not Updated"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default IndividualTaslTable
